export default "__VITE_ASSET__DV_qebsu__"